import { TOrderStatusEnum } from 'api/orders/orders.types';
import { TOrderFormValues } from './OrderForm.types';
import { isoToDatetimeLocalValue } from './OrderForm.utils';

const newHexId = (len: number) =>
  Array.from({ length: len }, () =>
    Math.floor(Math.random() * 16).toString(16)
  ).join('');

export const getEmptyOrderFormValues = (): TOrderFormValues => {
  const now = new Date().toISOString();

  return {
    id: newHexId(24),
    orderNumber: '',
    totalPrice: 0,
    status: TOrderStatusEnum.Created,
    payed: false,
    receiveNotifications: false,
    policyAccepted: false,
    isManualPayment: false,
    manualPaymentDate: '',
    manualPaymentMethod: '',
    paymentJson: '{}',
    userId: '',
    createdAt: isoToDatetimeLocalValue(now),
    updatedAt: isoToDatetimeLocalValue(now),
    shippingData: {
      phone: '',
      city: '',
      postalCode: '',
      street: '',
      buildingNumber: '',
      apartamentNumber: '',
      firstName: '',
      lastName: '',
      deliveryMethod: 'inpost',
      parcelLockerCode: '',
      email: '',
      additionalInfo: '',
    },
    checkoutItems: [],
  };
};
